import gql from 'graphql-tag';

export const archiveMeterReadingValueMutation = gql(/* GraphQL */ `
  mutation archiveMeterReadingValueMutation(
    $meterReadingValueId: UUID!
    $channelId: String!
  ) {
    archiveMeterReadingValue(
      meterReadingValueId: $meterReadingValueId
      channelId: $channelId
    )
  }
`);
